import { Spinner } from "@cloudscape-design/components";
import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router";
import { LAST_VISIT_URL } from "@/utils/const";

const LoginCallback: React.FC = () => {
  const navigate = useNavigate();

  const gotoBasePage = useCallback(() => {
    const lastVisitUrl = localStorage.getItem(LAST_VISIT_URL);
    localStorage.removeItem(LAST_VISIT_URL);
    const publicUrl = process.env.PUBLIC_URL ?? "";
    const basePath = publicUrl.endsWith("/") ? publicUrl.slice(0, -1) : publicUrl;

    const stripBasePath = (pathname: string) => {
      if (!pathname) return "/";
      if (basePath && pathname.startsWith(basePath)) {
        return pathname.slice(basePath.length) || "/";
      }
      return pathname;
    };
    
    if (lastVisitUrl) {
      try {
        const url = new URL(lastVisitUrl, window.location.origin);
        const path = `${stripBasePath(url.pathname)}${url.search}${url.hash}`;
        navigate(path, { replace: true });
      } catch {
        const path = stripBasePath(lastVisitUrl);
        navigate(path, { replace: true });
      }
    } else {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    gotoBasePage();
  }, [gotoBasePage]);
  return (
    <div className="page-loading">
      <Spinner />
    </div>
  );
};

export default LoginCallback;
